/**
 * Safely parses the value from dropdown and returns the raw JSON value with extracted city and postal code.
 *
 * @param {string|string[]} value
 * @returns {{city: string, postalCode: string, json: string}}
 */
export function parseLocation(value) {
  const json = (Array.isArray(value) ? value[0] : value) || "{}";
  const { city = "", postalCode = "" } = JSON.parse(json);

  return { city, postalCode, json };
}
